import { gql } from '@apollo/client'

export const ASSIGN_CASE_EMAIL_MUTATION = gql`
  mutation AssignCaseEmail($emailId: ID!, $caseId: ID!, $processingId: ID) {
    assignCaseEmail(emailId: $emailId, caseId: $caseId, processingId: $processingId) {
      caseEmail {
        id
        m2Case {
          id
          identifier
        }
      }
      errors
    }
  }
`
